import React from 'react'

const RoleMapping = () => {
  return <div>Role Mapping</div>
}
export default RoleMapping
